import Vue from "vue";
import moment from "moment";
import { firestore } from "firebase/app";

Vue.filter("camelToWords", (value: string) => {
  if (value) {
    const decamelized = value
      .replace(/([A-Z]+)/g, " $1")
      .replace(/([A-Z][a-z])/g, " $1");
    return decamelized.charAt(0).toUpperCase() + decamelized.substring(1);
  }
});

Vue.filter("timestampToDate", (timestamp: any) => {
  if (timestamp) {
    return moment
      .unix(timestamp.seconds ?? timestamp._seconds)
      .format("YYYY/MM/DD");
  }
});

Vue.filter(
  "getAgeAtTimestamp",
  (timestampA: firestore.Timestamp, timestampB: firestore.Timestamp) => {
    if (timestampA) {
      const a = moment.unix(timestampA.seconds);
      const b = timestampB ? moment.unix(timestampB.seconds) : moment();
      const years = b.diff(a, "year");
      a.add(years, "years");
      const months = b.diff(a, "months");
      a.add(months, "months");
      const weeks = b.diff(a, "weeks");
      a.add(weeks, "weeks");
      const days = b.diff(a, "days");
      return `${years}y ${months}m ${weeks}w ${days}d`;
    }
  }
);
